import { apiClient } from "@/services/apiClient";

export type AllowedDomainDto = {
  domain: string;
};

export type CreateAllowedDomainRequestDto = {
  action: "Add" | "Remove";
  requester: string;
  serviceNow?: string | null;
  domain: string;
};

export type CreateAllowedDomainRequestResponse = {
  message: string;
  correlationId: string;
  sharePointItemId?: string | null;
};

export async function getAllowedDomains(): Promise<AllowedDomainDto[]> {
  const res = await apiClient.get<AllowedDomainDto[]>("/api/allowed-domains");
  return res.data;
}

export async function createAllowedDomainRequest(
  dto: CreateAllowedDomainRequestDto
): Promise<CreateAllowedDomainRequestResponse> {
  const res = await apiClient.post<CreateAllowedDomainRequestResponse>(
    "/api/allowed-domains/requests",
    dto
  );
  return res.data;
}